/**
 * @fileoverview GET handler for the "/companies/:company_id/developers_common" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { sparseDevelopersCacheKey } from "./constants";
import type { SparseDeveloper } from "./types";

export const getSparseDevelopers = reactQueryFetcherAdapter(
  sparseDevelopersCacheKey,
  (signal: AbortSignal, companyId: string): Promise<SparseDeveloper[]> => {
    return fetch(`/companies/${companyId}/developers_common`, "GET", undefined, { signal });
  }
);
